<template>
	<v-row class="mb-2">
		<!-- Card 1: Total Counted -->
		<v-col cols="12" sm="6" md="3">
			<v-card dark outlined class="stats-kpi-card pa-3">
				<div class="d-flex align-center justify-space-between mb-1">
					<div class="caption grey--text text-uppercase letter-spacing-1">{{ $ml.get('alarm_stats_total_counted') }}</div>
					<v-icon color="#FFA726" small>mdi-counter</v-icon>
				</div>
				<div class="text-h4 font-weight-bold" style="color:#FFA726;">
					{{ formatNumber(totalCount) }}
				</div>
				<div class="caption grey--text mt-1" style="color:#FFB74D !important;">
					<v-icon x-small style="color:#FFB74D;">mdi-plus</v-icon>
					{{ formatNumber(perMinute) }} {{ $ml.get('alarm_stats_this_minute') }}
				</div>
			</v-card>
		</v-col>

		<!-- Card 2: Good Units -->
		<v-col cols="12" sm="6" md="3">
			<v-card dark outlined class="stats-kpi-card pa-3">
				<div class="d-flex align-center justify-space-between mb-1">
					<div class="caption grey--text text-uppercase letter-spacing-1">{{ $ml.get('alarm_stats_good_units') }}</div>
					<v-icon color="#66BB6A" small>mdi-check-circle-outline</v-icon>
				</div>
				<div class="text-h4 font-weight-bold" style="color:#66BB6A;">
					{{ formatNumber(goodCount) }}
				</div>
				<div class="mt-2">
					<div class="d-flex justify-space-between caption mb-1" style="color:#66BB6A;">
						<span>{{ $ml.get('alarm_stats_quality_rate') }}</span>
						<span>{{ qualityRate }}%</span>
					</div>
					<v-progress-linear
						:value="qualityRateValue"
						color="#66BB6A"
						background-color="#2D2D2D"
						height="6"
						rounded
					></v-progress-linear>
				</div>
			</v-card>
		</v-col>

		<!-- Card 3: Defects -->
		<v-col cols="12" sm="6" md="3">
			<v-card dark outlined class="stats-kpi-card pa-3">
				<div class="d-flex align-center justify-space-between mb-1">
					<div class="caption grey--text text-uppercase letter-spacing-1">{{ $ml.get('alarm_stats_defects') }}</div>
					<v-icon color="#EF5350" small>mdi-alert-circle-outline</v-icon>
				</div>
				<div class="text-h4 font-weight-bold" style="color:#EF5350;">
					{{ formatNumber(defectCount) }}
				</div>
				<div class="caption mt-1" style="color:#EF5350;">
					{{ defectRate }}% {{ $ml.get('alarm_stats_defect_rate') }}
				</div>
			</v-card>
		</v-col>

		<!-- Card 4: Stoppages -->
		<v-col cols="12" sm="6" md="3">
			<v-card dark outlined class="stats-kpi-card pa-3">
				<div class="d-flex align-center justify-space-between mb-1">
					<div class="caption grey--text text-uppercase letter-spacing-1">{{ $ml.get('alarm_stats_stoppages') }}</div>
					<v-icon color="#26C6DA" small>mdi-stop-circle-outline</v-icon>
				</div>
				<div class="text-h4 font-weight-bold" style="color:#26C6DA;">
					{{ stoppagesCount }}
				</div>
				<div class="caption mt-1" style="color:#26C6DA;">
					{{ $ml.get('alarm_stats_total_idle') }}: {{ formatDuration(totalIdleMs) }}
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name : 'StatsKpiCards',

	props : {
		totalCount : {
			type    : Number,
			default : 0,
		},
		goodCount : {
			type    : Number,
			default : 0,
		},
		defectCount : {
			type    : Number,
			default : 0,
		},
		stoppagesCount : {
			type    : Number,
			default : 0,
		},
		totalIdleMs : {
			type    : Number,
			default : 0,
		},
		perMinute : {
			type    : Number,
			default : 0,
		},
	},

	computed : {
		qualityRateValue() {
			if (!this.totalCount) return 0;
			return Math.min(100, Math.round((this.goodCount / this.totalCount) * 100));
		},

		qualityRate() {
			return this.qualityRateValue.toFixed(1);
		},

		defectRate() {
			if (!this.totalCount) return '0.0';
			return Math.min(100, ((this.defectCount / this.totalCount) * 100)).toFixed(1);
		},
	},

	methods : {
		formatNumber(value) {
			if (value === null || value === undefined) return '0';
			return Number(value).toLocaleString();
		},

		formatDuration(ms) {
			if (!ms || ms <= 0) return '0m';
			const totalSeconds = Math.floor(ms / 1000);
			const hours        = Math.floor(totalSeconds / 3600);
			const minutes      = Math.floor((totalSeconds % 3600) / 60);
			const seconds      = totalSeconds % 60;
			if (hours > 0) return `${hours}h ${minutes}m`;
			if (minutes > 0) return `${minutes}m ${seconds}s`;
			return `${seconds}s`;
		},
	},
};
</script>

<style scoped>
.stats-kpi-card {
	background-color: #1E1E1E !important;
	border-color: #2D2D2D !important;
	min-height: 110px;
}

.letter-spacing-1 {
	letter-spacing: 0.05em;
}
</style>
